export default "__VITE_ASSET__4a2c02ae__"